export default __webpack_public_path__ + "static/media/Group 845.483c9c90.svg";